import React from 'react';
import PropTypes from 'prop-types';

const FilterIcon = ({color = '#2F343B', width = 'auto', height = 'auto', className = ''}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>filter-32px</title>
    <g stroke={color} fillRule="evenodd">
      <path
        fill={color}
        d="M4.61193557,29.0909091 L0,29.0909091 L0,26.1818182 L4.61193557,26.1818182 C5.21097035,24.4869929 6.82731808,23.2727273 8.72727272,23.2727273 C11.1372425,23.2727273 13.0909091,25.2263938 13.0909091,27.6363637 C13.0909091,30.0463333 11.1372425,32 8.72727272,32 C6.82731808,32 5.21097035,30.7857344 4.61193557,29.0909091 Z M4.61193557,5.81818181 L0,5.81818181 L0,2.90909091 L4.61193557,2.90909091 C5.21097035,1.21426564 6.82731808,0 8.72727272,0 C11.1372425,0 13.0909091,1.95366655 13.0909091,4.36363637 C13.0909091,6.77360619 11.1372425,8.72727272 8.72727272,8.72727272 C6.82731808,8.72727272 5.21097035,7.51300709 4.61193557,5.81818181 Z M27.3880645,17.4545455 C26.7890296,19.1493707 25.1726819,20.3636364 23.2727273,20.3636364 C20.8627575,20.3636364 18.9090909,18.4099698 18.9090909,16 C18.9090909,13.5900302 20.8627575,11.6363636 23.2727273,11.6363636 C25.1726819,11.6363636 26.7890296,12.8506293 27.3880645,14.5454545 L32,14.5454545 L32,17.4545455 L27.3880645,17.4545455 Z M17.4545455,14.5454545 L17.4545455,17.4545455 L0,17.4545455 L0,14.5454545 L17.4545455,14.5454545 Z M32,2.90909091 L32,5.81818181 L14.5454545,5.81818181 L14.5454545,2.90909091 L32,2.90909091 Z M32,26.1818182 L32,29.0909091 L14.5454545,29.0909091 L14.5454545,26.1818182 L32,26.1818182 Z"
        id="Combined-Shape"
      />
    </g>
  </svg>
);

FilterIcon.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,

  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * Icon width
   */
  width: PropTypes.string,

  /**
   * Icon height
   */
  height: PropTypes.string,
};
export default FilterIcon;
